import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId } from '../../../sites';

import ViinimaaMessageQueue from './viinimaa';

function MessageQueue(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaMessageQueue {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaMessageQueue {...props} />;
  }
  if (isEqual(siteId, siteIds.AnoraPro)) {
    return <ViinimaaMessageQueue {...props} />;
  }

  return null;
}

export default MessageQueue;
